import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PdfFormService {
  private baseUrl = `${environment.baseApiUrl}/pdf-forms`;

  constructor(private http: HttpClient) { }

  async savePdfForm(formData: any, jobId: string, readyToDeliver: boolean = false): Promise<any> {
    try {
      const response = await firstValueFrom(
        this.http.post(`${environment.baseApiUrl}/jobs/save-pdf/${jobId}?readyToDeliver=${readyToDeliver}`, formData)
      );
      return response;
    } catch (error) {
      console.error('Error saving PDF form data:', error);
      throw error;
    }
  }

  async getFormData(jobId: string): Promise<any> {
    try {
      const response = await firstValueFrom(this.http.get(`${this.baseUrl}/jobs/save-pdf-form-data-json/${jobId}`));
      return response;
    } catch (error) {
      console.error('Error getting PDF form data:', error);
      throw error;
    }
  }

  async updateFormData(formData: any, jobId: string): Promise<any> {
    try {
      const response = await this.http.put(`${this.baseUrl}/${jobId}`, formData).toPromise();
      return response;
    } catch (error) {
      console.error('Error updating PDF form data:', error);
      throw error;
    }
  }

  async _setReadyToDeliver(jobId: number): Promise<any> {
    try {
      const response = await firstValueFrom(
        this.http.get(`${environment.baseApiUrl}/jobs/set-ready-to-deliver/${jobId}`, {})
      );
      return response;
    } catch (error) {
      console.error('Error setting job as ready to deliver:', error);
      throw error;
    }
  }
} 